import { useState, useEffect, useCallback } from "react";
import { getClassi, getAnniDisponibili } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

export default function ClassiPage() {
  const { annoCorrente } = useAuth();
  const [classi, setClassi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [localAnno, setLocalAnno] = useState(null);
  const [anniList, setAnniList] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await getAnniDisponibili();
        const anni = res.data.anni || [];
        setAnniList(anni);
        setLocalAnno(anni.includes(annoCorrente) ? annoCorrente : (anni[0] || null));
      } catch (e) { console.error(e); }
    })();
  }, [annoCorrente]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try { const res = await getClassi(localAnno); setClassi(res.data.data); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [localAnno]);
  useEffect(() => { fetchData(); }, [fetchData]);

  return (
    <div data-testid="classi-page">
      <div className="sw-page-title"><h1>Classi</h1><div className="sw-breadcrumb">Home &gt; Classi</div></div>
      <div className="sw-filter-box">
        <div className="sw-filter-row">
          <span className="sw-filter-label">anno:</span>
          <select value={localAnno||""} onChange={e=>setLocalAnno(e.target.value?parseInt(e.target.value):null)} className="sw-filter-select">
            <option value="">Tutti</option>
            {anniList.map(a=><option key={a} value={a}>{a}-{String(a+1).slice(2)}</option>)}
          </select>
        </div>
      </div>
      <div style={{margin:"4px 20px",fontSize:12,color:"#666"}}>{classi.length} classi trovate</div>
      <div className="sw-table-container">
        <table className="sw-table">
          <thead><tr><th>#</th><th>Settore</th><th>Classe</th><th>N. Alunni</th></tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={4} className="sw-loading">Caricamento...</td></tr>
            : classi.length === 0 ? <tr><td colSpan={4} className="sw-empty"><p>Nessuna classe trovata</p></td></tr>
            : classi.map((c,i) => (
              <tr key={`${c.ClaId}-${c.anno}`} data-testid={`classe-row-${c.ClaId}`}>
                <td className="center-col" style={{color:"#888"}}>{i+1}</td>
                <td className="center-col" style={{fontWeight:600}}>{c.SetNom}</td>
                <td style={{fontWeight:600}}>{c.ClaNom}</td>
                <td className="num-col">{c.num_alunni}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
